import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import ChevronRight from '../svg/ChevronRight'

function NextV2({ onClick, style }) {
  return (
    <div onClick={onClick} className={`pag-chevron-v2 right flexColumn f-center`} style={{style}}>
      <ChevronRight color={ Config.TYPE_PLACEHOLDER } />
    </div>
  )
}

NextV2.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object
}

export default NextV2;
